import { PdfViewer } from './components';

export default PdfViewer;
